"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var ChecklistRow =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(ChecklistRow, _React$Component);

  function ChecklistRow() {
    (0, _classCallCheck2.default)(this, ChecklistRow);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ChecklistRow).apply(this, arguments));
  }

  (0, _createClass2.default)(ChecklistRow, [{
    key: "render",
    value: function render() {
      var result = this.props.result;
      var localizedTextKey = result.localizedTextKey;
      return _react.default.createElement("tr", null, _react.default.createElement("td", null, _react.default.createElement(_FormattedMessage.default, {
        message: localizedTextKey + ".header"
      })), _react.default.createElement("td", null, result.displayValue, _react.default.createElement("span", null, result.displayValueUnit)), _react.default.createElement("td", null, result.displayRecommendationValue, _react.default.createElement("span", null, result.displayRecommendationValueUnit)), _react.default.createElement("td", null, _react.default.createElement(_FormattedMessage.default, {
        message: localizedTextKey + ".result.recommendation"
      })));
    }
  }]);
  return ChecklistRow;
}(_react.default.Component);

exports.default = ChecklistRow;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/ChecklistRow.js
// module id = 267
// module chunks = 0